<template>
  <!-- 主题详情 -->
  <div>
    <!-- 搜索框 -->
    <scroller :on-refresh="refresh">
      <div class="container">
        <div class="row">
          <div class="col-md-8" style="margin: 0 auto">
            <Search :pages="routeLive" />
            <div class="catImg">
              <img :src="catDetail.catCoverImg" />
            </div>

            <div class="catDetail">
              <div class="catTitle">
                <p>
                  <span>{{ catDetail.catName }}</span>
                  <span style="float: right" @click="attention">{{
                    attentionType ? '已关注' : '关注'
                  }}</span>
                </p>
                <!-- <p @click="attention">
                  <span>{{attentionType?'已关注':'关注'}}</span>
                </p>-->
              </div>
              <div class="catIntr">
                <div class="catIntr-title">
                  <img src="../../assets/img/list1.png" alt />
                  <span>专题介绍</span>
                  <img
                    style="float: right; margin-top: 5px"
                    @click="showMenu"
                    :src="
                      !menuShow
                        ? require('../../assets/img/menu_down.png')
                        : require('../../assets/img/menu_up.png')
                    "
                    alt
                  />
                </div>
                <p
                  v-if="!menuShowAll && !menuShow"
                  v-html="catDetail.catDetail"
                  class="intrTheme"
                  @click="imageChgange($event)"
                  :class="{ contextShowAll: !menuShowAll }"
                ></p>

                <p
                  v-if="menuShow || !menuShowAll"
                  v-html="catDetail.catDetail"
                  class="intrTheme"
                  @click="imageChgange($event)"
                  :class="{ contextShow: !menuShow }"
                ></p>
                <div class="AllShadow">
                  <mt-button
                    type="primary"
                    size="large"
                    v-if="!menuShowAll && !menuShow"
                    @click="showMenuAll"
                    >点击展开全文</mt-button
                  >
                </div>
              </div>
              <!-- <div class="menu_show"></div> -->
            </div>
            <!-- 推荐主题 -->
            <div class="catIntr">
              <div class="catIntr-title">
                <img src="../../assets/img/recommend.png" alt />
                <span>直播列表</span>
              </div>
              <mt-navbar
                v-model="selected"
                style="width: 50%"
                v-show="columnList.length === 1"
              >
                <mt-tab-item
                  :id="item.catId"
                  v-for="(item, index) in columnList"
                  :key="index"
                  >{{ item.catName }}</mt-tab-item
                >
              </mt-navbar>

              <mt-navbar v-model="selected" v-show="columnList.length > 1">
                <mt-tab-item
                  :id="item.catId"
                  v-for="(item, index) in columnList"
                  :key="index"
                  >{{ item.catName }}</mt-tab-item
                >
              </mt-navbar>

              <!-- 列表显示区域 -->
              <mt-tab-container v-model="selected">
                <!-- 二级分类区 -->
                <mt-tab-container-item
                  :id="item.catId"
                  v-for="(item, index) in columnList"
                  :key="index"
                >
                  <div class="navItem">
                    <info-item :catId="item.catId"></info-item>
                  </div>
                </mt-tab-container-item>
              </mt-tab-container>
            </div>
          </div>
        </div>
      </div>
    </scroller>
  </div>
</template>

<script>
import { ImagePreview } from 'vant'
import Search from '../../components/Search'
import InfoItem from '../../components/InfoItem'
export default {
  // props: ['catId'],
  components: { Search, InfoItem },
  beforeRouteLeave(to, form, next) {
    var node = document.getElementsByTagName('body')[0]
    if (node.classList.contains('van-overflow-hidden')) {
      this.$router.go(1)
      return
    }
    next()
  },
  data() {
    return {
      menuShow: false,
      menuShowAll: false,
      catId: this.$route.query.catId,
      selected: this.$route.query.catId,
      catDetail: {},
      userId: '',
      attentionType: false,
      interestId: '',
      columnList: [],
      dataForm: {
        liveList: [],
      },
      catIds: [],
      routeLive: '',
    }
  },
  mounted() {
    this.userId = sessionStorage.getItem('userId')
    this.routeLive = sessionStorage.getItem('routeLive')
    this.getColumn()
    this.getUserInterest()
    this.getColumnList()
    this.noShare()
  },
  methods: {
    imageChgange(e) {
      if (e.target.nodeName == 'IMG') {
        ImagePreview({
          images: [e.target.currentSrc], //e.target.currentSrc  当前图片src
          showIndex: false,
          loop: false,
        })
      } else {
        return
      }
    },
    showMenu() {
      this.menuShow = !this.menuShow
    },
    showMenuAll() {
      this.menuShowAll = !this.menuShowAll
      this.menuShow = true
    },
    refresh() {
      location.reload()
    },
    // 加载更多
    loadMore() {
      this.pageIndex++
      if (this.pageIndex <= this.dataForm.totalPage) {
        this.getLiveList()
      }
    },
    // 获取栏目列表
    getColumnList() {
      this.$http({
        url: `live/liveCategory/queryCategoryChildren/${this.catId}`,
        methods: 'get',
      }).then(({ data }) => {
        if (data && data.code === 0) {
          let arr = []
          this.getChildrens(arr, data.data[0])
          this.selected = arr[0].catId
          this.columnList = arr
          this.columnList.forEach((e) => {
            this.catIds.push(e.catId)
          })

          this.getLiveList()
        }
      })
    },
    getChildrens(arr, node) {
      arr.push(node)
      node.children.forEach((e) => {
        this.getChildrens(arr, e)
      })

      if (
        node.children === null ||
        node.children === undefined ||
        node.children === '' ||
        node.children.length < 1
      ) {
        return arr
      }

      return arr
    },
    // 获取栏目列表
    getLiveList() {
      this.$http({
        url: `/live/liveCategory/queryCategoryAllLives/${this.catIds.join(
          '_'
        )}`,
        method: 'get',
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataForm.liveList = data.data
        } else {
          this.dataForm.liveList = []
          this.pageIndex = 1
        }
      })
    },
    getDetail(liveId) {
      // this.$router.push({
      //   path: '/details',
      //   query: {
      //     liveId: liveId,
      //   },
      // })
       const routeData = this.$router.resolve({
        path: '/details/',
        query: { liveId: liveId }
      })
    },

    // 查询当前用户是否关注该主题
    getUserInterest() {
      this.$http({
        url: '/live/userInterest/checkInterest',
        method: 'get',
        params: {
          userId: this.userId,
          catId: this.catId,
          status: 1,
        },
      }).then(({ data }) => {
        this.attentionType = data.code === 0
      })
    },
    attention() {
      if (this.attentionType) {
        this.cancleAttention()
      } else {
        this.addAttention()
      }
    },
    // 添加关注
    addAttention() {
      let flag = false
      if (!flag) {
        flag = true
        this.$http({
          url: '/live/userInterest/save',
          method: 'post',
          data: {
            catId: this.catId,
            userId: this.userId,
            status: 1,
          },
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.attentionType = true
            this.$toast('已关注')
            this.getUserInterest()
          } else {
            this.attentionType = false
            this.$toast('关注失败，请稍后再试')
          }
        })
      }
    },
    // 取消关注
    cancleAttention() {
      this.$http({
        url: '/live/userInterest/removeInterest',
        method: 'delete',
        data: {
          userId: this.userId,
          catId: this.catId,
          status: 1,
        },
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.attentionType = false
          this.$toast('取消关注')
        } else {
          this.attentionType = true
          this.$toast('取消关注失败，请稍后再试')
        }
      })
    },
    // 获取主题
    getColumn() {
      this.$http({
        url: `live/liveCategory/info/${this.catId}`,
        method: 'get',
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.$http({
            url: `/live/topicCat/saveTopicCat`,
            method: 'post',
            params: {
              userId: this.userId,
              catId: this.catId,
            },
          }).then(({ data }) => {})
          this.catDetail = data.data
        } else {
          this.catDetail = {}
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.infoItemDes2 {
  line-height: 15px;
  color: #666;
  overflow: hidden;
  font-size: 10px;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  // margin: 5px 0;
}
.AllShadow {
  text-align: center;
  cursor: pointer;
  color: #666;
  font-size: 14px;
  margin-top: 5px;
}
.contextShow {
  display: none;
}
.contextShowAll {
  max-height: 200px;
  overflow: hidden;
}
.menu_show {
  text-align: right;
  border-bottom: 5px solid #eee;
  img {
    width: 24px;
    display: inline-block;
    margin-right: 2rem;
  }
}
.noCourse {
  text-align: center;
  padding: 20px 0;
  color: #666;
  font-size: 14px;
}
/* 每一个图文项目的外层 */
a {
  text-decoration: none;
  color: #333;
}
.inforItemText {
  margin-left: 2rem;
  width: 65%;
  // line-height: 35px;
}
/* 图文项目的标题信息 */
.infoItemTitle {
  font-size: $font-title2;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: -o-ellipsis-lastline;
}
/* 图文项目的内容信息(弹性布局) */
.infoItemContent:last-child {
  border-bottom: 0;
}
.infoItemContent {
  display: flex;
  align-items: center;
  padding: 0.2rem 0;
  margin: 0.2rem 0;
  width: 100%;
  border-bottom: 1px solid #eee;
  .liveImg {
    position: relative;
    .liveStatus {
      position: absolute;
      right: 0;
      bottom: 0;
      color: #fff;
      padding: 2px 1rem;
      border-radius: 1rem;
      font-size: 12px;
      background-color: rgba($color: #000000, $alpha: 0.8);
    }
  }
}
/* 图文项目的内容信息--图片 */
.infoItemImg {
  width: 100px;
  height: 80px;
  border-radius: 5px;
}
/* 图文项目的内容信息--简介 */
.infoItemDes {
  line-height: 20px;
  color: #666;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  margin: 5px 0;
}
.infoItemPrice {
  font-size: 14px;
  color: #999;
  padding-bottom: 5px;
  .free {
    padding: 2px;
    margin-right: 1rem;
    font-size: 12px;
    background-color: $theme-color;
    border-radius: 3px;
    color: #fff;
  }
  .price {
    padding: 2px;
    margin-right: 1rem;
    color: $theme-color;
    span {
      margin-left: 5px;
    }
  }
}
.intrTheme {
  color: #333;
  font-size: 14px;
  line-height: 30px;
  width: 100%;
  padding: 0 10px;
  text-indent: 2em;
  word-break: break-all;
}
.catImg {
  // width: 100%;
  height: 20rem;
  margin: 0 1rem;

  img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
}
.catDetail {
  .catTitle {
    padding: 1.5rem;
    padding-bottom: 0;
    border-radius: 1rem;
    font-size: 18px;
    font-weight: bold;
    background-color: #fff;

    span:nth-child(2) {
      background-color: $theme-color;
      font-size: 12px;
      border-radius: 2rem;
      padding: 2px 8px;
      color: #fff;
    }
  }
}
.catCompany {
  color: #666;
  p {
    font-size: 16px;
    margin: 1rem 0;
  }
}
.catIntr {
  padding: 1rem 15px;
  // border-bottom: 10px solid #eee;
  .catIntr-title {
    // display: flex;
    // align-items: center;
    padding-bottom: 1rem;
    img {
      display: inline-block;
      width: 20px;
      margin-bottom: 5px;
      margin-right: 5px;
      border-radius: 5px;
    }
    span {
      font-size: $font-title;
      padding-left: 5px;
      // font-weight: bold;
    }
  }
}
::v-deep img {
  width: 100%;
  display: block;
}
</style>
